import { render, staticRenderFns } from "./CommentsThread.vue?vue&type=template&id=7aa8eb20&scoped=true"
import script from "./CommentsThread.vue?vue&type=script&lang=js"
export * from "./CommentsThread.vue?vue&type=script&lang=js"
import style0 from "./CommentsThread.vue?vue&type=style&index=0&id=7aa8eb20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa8eb20",
  null
  
)

export default component.exports